import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";
import * as L from 'leaflet';

export const LOCATION_HIE: any = ['COUNTRY','STATE','DISTRICT', 'BLOCK']
export const HEATWAVE_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
            layer_name: 'District Boundary',
            layeroptions_pane: 'district',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN -1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'HEATWAVE_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'HEATWAVE_LEGEND',
            layeroptions_protocol: 'WFS'
        },
    }
}

export const HEATWAVE_SCHOOL_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'School Points': {
            source: 'INDIA',
            displayName: 'Schools',
            name: 'School Points',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_SCHOOLS',
            layer_name: 'School Points',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'Dist_UUID',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            applycql_filter: true,
            // legendName: 'HEATWAVE_LEGEND',
            // layeroptions_protocol: 'WFS'
        },
        'Anganwadi Points': {
            source: 'INDIA',
            displayName: 'Anganwadi',
            name: 'Anganwadi Points',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:anganwadi_points_telangana',
            layer_name: 'Anganwadi Points',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'dist_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            applycql_filter: true,
            // legendName: 'HEATWAVE_LEGEND',
            // layeroptions_protocol: 'WFS'
        },
        'Healthcare Points': {
            source: 'INDIA',
            displayName: 'Healthcare',
            name: 'Healthcare Points',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:healthcare_facility_points',
            layer_name: 'Healthcare Points',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'dist_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            applycql_filter: true,
            // legendName: 'HEATWAVE_LEGEND',
            // layeroptions_protocol: 'WFS'
        },
    }
}

export const HEATWAVE_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        HEATWAVE_LEGEND: {
            // "Units": "Heatwave ",
            "colorValues": [
                {
                    backgroundColor : '#B22222',
                    text: 'Severe Heatwave',
                    textColor: '#ffffff'
                },
                {
                    backgroundColor : '#FFA500',
                    text: 'Heatwave',
                    textColor: '#000000'
                },
                {
                    backgroundColor : '#9edbab',
                    text: 'Normal',
                    textColor: '#000000'
                }
             ]
        }
    }
}